export default "__VITE_ASSET__73dff662__"